// extracted by mini-css-extract-plugin
module.exports = {"uploader":"Uploader_uploader__3SQYN","left":"Uploader_left__4-And","right":"Uploader_right__KampM"};